import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  InputAdornment,
  Switch,
  TextField,
} from '@mui/material';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import '../ApplicantsNewDashboard.css';
import {
  configuration,
  postingColumnData,
  applicantColumnData,
} from '../widget';
import CardTitle from '../CardTitle/CardTitle';
import { Encrypt, decrypt } from '../../../../_utilities/_encryptDecryptHelper';
import { useNavigate } from 'react-router-dom';
import useUnsavedChangesWarning from '../../../../hooks/useUnsavedChangesWarning';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseIcon from '@mui/icons-material/Close';

import { GetUserInfo } from '../../../../_utilities/getUserInfo';
const TableWidgetCard = ({
  card,
  showToggle = false,
  switchChange,
  editMode,
  handleSaveCardTitle,
  handleDeleteCard,
  handleEditCard,
  handleCardTitle,
  cardTitleChangeId,
  dynamicHeight,
}) => {
  const data = card.data;
  const [toggle, switchToggle] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [config, setConfig] = useState(configuration);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const navigate = useNavigate();

  useUnsavedChangesWarning(
    unsavedChanges,
    'You have unsaved changes. Are you sure you want to leave?'
  );

  let IsAllcountries = JSON.parse(decrypt('allCountryId'));

  useEffect(() => {
    if (card.type === 'candidateDetailsByStatus' && data) {
      updateConfig(data);
    }
  }, [card.type, data]);

  useEffect(() => {
    async function processData() {
      if (IsAllcountries !== '' || IsAllcountries !== null) {
        let userData = await GetUserInfo();
        let userCountries = userData
          ? JSON.parse(userData[0].selectedcountries)
          : [];
        if (data && data.length > 0) {
          data.forEach((item) => {
            let countryIndex = userCountries?.findIndex(
              (x) => x.id === item.countryId
            );
            if (countryIndex !== -1) {
              item['countryLogo'] = userCountries[countryIndex].logo;
              item['countryName'] = userCountries[countryIndex].name;
            }
          });
        }
      }
    }
    processData();
  }, [data, IsAllcountries]);

  const updateConfig = (data) => {
    let updatedConfig = { ...configuration };
    updatedConfig.isPaging = true;
    updatedConfig.recordperPage = 8;
    updatedConfig.totalRecords = data.length ?? 0;
    updatedConfig.limitData = 20;
    updatedConfig.isCheckAlignRight = false;
    updatedConfig.currentPage = 1;
    setConfig(updatedConfig);
  };

  let headerCountry = JSON.parse(decrypt('selectCountryId'));

  const onReceiveActionHandler = async (type, object) => {
    if (object?.countryId && headerCountry !== object?.countryId) {
      const confirmLeave = window.confirm(
        `You are about to view job details from ${object.countryName}. The application will now display all information specific to ${object.countryName}. Do you want to proceed?`
      );
      if (confirmLeave) {
        // Navigate to view page
        Encrypt(JSON.stringify(object.countryId), 'selectCountryId');
        let country = {
          id: object.countryId,
          name: object.countryName,
          logo: object.countryLogo,
        };
        Encrypt(JSON.stringify(country), 'selectCountry');
        navigate(`/ats/layout/jobpostings/view/${object.id}`);
      } else {
        // Cancel navigation or do nothing
        console.log('User canceled navigation');
      }
    } else if (type !== 'scroll') {
      if (card.type === 'requirementsWidget') {
        navigate(`/ats/layout/jobpostings/view/${object.id}`);
      } else {
        navigate(`${object.nagigate}/${object.id}`);
      }
    }
  };

  const filterObjHandler = (value) => {
    setFilterValue(value);
    const updateData = [...card.data];
    let data = [];
    if (value) {
      data = updateData.filter((x) =>
        Object.keys(x).some((k) =>
          String(x[k]).toLowerCase().includes(value.toLowerCase())
        )
      );
      if (data.length > 0) {
        setFilterData(data);
        updateConfig(data);
      } else {
        setFilterData([]);
        updateConfig(data);
      }
    } else {
      updateConfig(card.data);
      setFilterData(null);
    }
  };

  return (
    <Card className="dashboard__card">
      <CardTitle
        card={card}
        editMode={editMode}
        handleSaveCardTitle={handleSaveCardTitle}
        handleDeleteCard={handleDeleteCard}
        handleEditCard={handleEditCard}
        handleCardTitle={handleCardTitle}
        cardTitleChangeId={cardTitleChangeId}
      />
      <CardContent style={{ position: 'relative' }}>
        {showToggle && (
          <div style={{ textAlign: 'right' }}>
            <div className="switch-container" id="dashboardBtn">
              <span className="text">Individual</span>
              <Switch
                checked={toggle}
                className="activeBtns"
                name="pieChartIndividualORTeam"
                onChange={() => {
                  const value = !toggle;
                  switchToggle(value);
                  switchChange(value);
                }}
              />
              <span className="text">Team</span>
            </div>
          </div>
        )}
        {data?.length > 0 ? (
          <>
            {card.type !== 'requirementsWidget' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px',
                }}
              >
                <TextField
                  id="standard-basic"
                  variant="standard"
                  style={{ width: '407px', padding: '7px 0 7px 15px' }}
                  placeholder="Search By Applicant Name, Job Title, Recruiter Name, Client, Status"
                  className="adSearchBox"
                  value={filterValue}
                  onChange={(e) => filterObjHandler(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {filterValue ? (
                          <CloseIcon
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              setFilterData(null);
                              setFilterValue('');
                              updateConfig(card.data);
                            }}
                          />
                        ) : (
                          <SearchOutlinedIcon style={{ cursor: 'pointer', color: '#a1a1a1' }} />
                        )}
                      </InputAdornment>
                    ),
                    disableUnderline: true,
                  }}
                />
              </div>
            )}
            <div className="widgetDashboard">
              <DynamicTable
                config={config}
                data={filterData ?? data ?? []}
                colmns={
                  card.type === 'requirementsWidget'
                    ? postingColumnData
                    : applicantColumnData
                }
                actionDropdown={[]}
                actions={[]}
                filterValue={''}
                noDataText={
                  card.type === 'requirementsWidget'
                    ? 'No Postings found'
                    : 'No data found'
                }
                addModel={{}}
                searchKeyWord=""
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
                tableMaxheight={dynamicHeight}
              />
            </div>
          </>
        ) : (
          <div className="dashboard__card-no-data-container">
            No Candidates Found
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(TableWidgetCard);
